import Link from 'next/link';
import { Box, Divider, List, ListItem, Typography } from '@mui/material';
import { BlogPageProps } from '../../../../pages/blog';
import { PostAuthor } from './PostAuthor';
import { PostSummary } from './PostSummary';
export const PostsListMobile = ({
  posts
}: BlogPageProps) => <List data-sentry-element="List" data-sentry-component="PostsListMobile" data-sentry-source-file="PostsListMobile.tsx">
    {posts.results.map(post => {
    const {
      authorFetchedName,
      authorAvatar,
      featuredImage,
      featuredImageAltText,
      publishDate,
      postReadTime,
      slug,
      postSummary,
      htmlTitle
    } = post;
    return <>
          <ListItem key={post.id} disablePadding>
            <Box component={Link} href={`/${slug}`} sx={{
          textDecoration: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: 1
        }}>
              <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
          }}>
                <Box>
                  <Typography variant="bodySmall" sx={{
                my: 1
              }}>{`${postReadTime} min read`}</Typography>
                  <Typography component="h2" variant="h5">
                    {htmlTitle}
                  </Typography>
                </Box>
                <Box sx={{
              position: 'relative',
              height: 70,
              minWidth: '35%'
            }}>
                  <img src={featuredImage} alt={featuredImageAltText} style={{
                objectFit: 'contain',
                objectPosition: 'right',
                position: 'absolute',
                height: '100%',
                width: '100%',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
              }} />
                </Box>
              </Box>
              <PostSummary postSummaryHtml={postSummary} />
              <PostAuthor authorName={authorFetchedName} authorAvatar={{
            src: authorAvatar,
            size: 32
          }} publishDate={publishDate} />
            </Box>
          </ListItem>
          <Divider sx={{
        mt: 2,
        mb: 1
      }} />
        </>;
  })}
  </List>;